import { useBrand } from '@edreamsodigeo/frontend-core';

const ASSET_URL = '/images/onefront/bluestone/images/prizefreeze';

const brands = {
  ED: null,
  OP: 'opodo',
  GO: 'govoyages',
};

export const useImagePathWithBrand = (img) => {
  const brand = useBrand();
  const regex = /\{brand}/g;
  const brandName = brands[brand] || brands.ED;
  if (!brandName) {
    return getImagePathNoBrand(img.replaceAll(regex, ''));
  }
  return `${ASSET_URL}/${brandName}/${img.replaceAll(regex, `_${brandName}`)}`;
};

export const getImagePathNoBrand = (img) => {
  return `${ASSET_URL}/${img}`;
};
